import React from "react";

export default function IntakeDetailsPanel({ client }) {
  if (
    !client.preferredContact &&
    !client.preferredTimeframe &&
    !client.source &&
    !client.mainBehaviorIssue
  ) {
    return null;
  }
  return (
    <div
      className="mt-4 grid gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm md:grid-cols-2"
      data-testid="lead-intake-info"
    >
      <p className="md:col-span-2 text-xs font-semibold uppercase tracking-wide text-amber-900">
        Intake details
      </p>
      {client.mainBehaviorIssue && (
        <div className="md:col-span-2">
          <p className="text-amber-800">Main issue</p>
          <p className="font-medium text-slate-900">{client.mainBehaviorIssue}</p>
        </div>
      )}
      {client.preferredContact && (
        <div>
          <p className="text-amber-800">Preferred contact</p>
          <p className="font-medium text-slate-900 capitalize">{client.preferredContact}</p>
        </div>
      )}
      {client.preferredTimeframe && (
        <div>
          <p className="text-amber-800">Timeframe</p>
          <p className="font-medium text-slate-900">{client.preferredTimeframe}</p>
        </div>
      )}
      {client.source && (
        <div className="md:col-span-2">
          <p className="text-amber-800">Heard about us via</p>
          <p className="font-medium text-slate-900">
            {client.source}
            {client.referrer ? ` (referrer: ${client.referrer})` : ""}
          </p>
        </div>
      )}
    </div>
  );
}
